export function openPopup() {
    const popup = document.querySelector('.js-popup');
    const body = document.body;
    popup.classList.add('-open');
    body.classList.add('-popupOpen');
}

export function closePopup() { 
    const popup = document.querySelector('.js-popup');
    const body = document.body;
    popup.classList.remove('-open');
    body.classList.remove('-popupOpen');
}

function addContentToPopup(url) {
    const content = document.querySelector('.js-popupContent');
    const img = document.createElement('img');
    img.src = url;
    content.innerHTML = '';
    content.appendChild(img);
}

document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener('click', function(e) {
        if (e.target.classList.contains('js-popupOpen')) {
            e.preventDefault();
            const url = e.target.getAttribute('data-popup-content');
            if (url) {
                addContentToPopup(url);
                openPopup();
            }
        } else if (e.target.classList.contains('js-popupDim')) {
            closePopup();
        } else if (e.target.closest('.js-popupClose')) {
            closePopup();
        }
    });
});
